export const events = {
  viewOneChat: 'View One Chat',
  clickSuggestedPrompt: 'Click Suggested Prompt',
  closeOneChat: 'Close One Chat',
  startedNewChatWithOne: 'Started new chat with One',
  messageFromOne: 'Message from One',
  clickOneFeedbackButton: 'Click One Feedback Button',
}
